import React from "react";

export default class NetmetrEnded extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <p>{this.props.message}</p>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./frontend/components/NetmetrEnded.jsx